import React, {ReactNode} from 'react';

import {StepType, TourProvider} from '@reactour/tour';
import {tourStyles} from 'src/modules/ai/tour/ai-tour.styles';

type Props = {
    children: ReactNode,
    steps: StepType[],
};

export const AiTourProvider = ({children, steps}: Props) => {
    const afterOpen = () => {
        document.body.style.overflow = 'hidden';
    };

    const beforeClose = () => {
        document.body.style.overflow = '';
    };

    return (
        <TourProvider
            steps={steps}
            afterOpen={afterOpen}
            beforeClose={beforeClose}
            styles={tourStyles}>
            {children}
        </TourProvider>
    );
};
